<template>
	<v-app>
		<v-layout row wrap style="overflow: hidden !important;">
  		<v-flex xs12 sm12 md12 xl12 style="margin-top: 3vh; height: 25vh;">
  			<v-layout align-center justify-center>
			    <div ref="fileform" style="width: 600px; border-radius: 5px; border-style: dotted; border-color: #f5f5f5; background-color: #009aff3d; text-align: center;">
            <img src='/static/img/onechat/box.png' style="margin-top: 10vh" width="65"/>
            <p style="font-size: 13px; font-weight: bold;">{{$t('Settings.feedback.selectmultipleFiles')}}</p>
            <p style="font-size: 13px; font-weight: bold;">── {{$t('Settings.feedback.or')}} ──</p>
            <label style="text-align: center; cursor: pointer; margin-bottom: 10vh;">
              <v-btn
                style="margin-bottom: 10vh; font-weight: bold;"
                color="primary"
                small 
                @click="openFileimage"
              >
                {{$t('AnswerQuestion.selectFile')}}
              </v-btn>
              <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
            </label>
            <!-- <img src='/static/img/onechat/box.png' width="50"/>
			      <label>
              <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกไฟล์</b>
			        <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
			      </label>
			      <span class="drop-files CSChatThai"> หรือลากไฟล์วางตรงนี้!</span> -->
			    </div>
  			</v-layout>
  		</v-flex>
      <v-layout align-end justify-center>
        <v-btn round outline color="primary" dark @click="submitallFiles()" v-if="files.length > 0 "> <i class="fas fa-upload" style="margin-bottom: 3px;"></i>&nbsp&nbsp{{$t('AnswerQuestion.uploadAll')}}</v-btn>
        <!-- <a @click="submitallFiles()" v-if="files.length > 0 "> <i class="fas fa-upload"></i> {{$t('AnswerQuestion.uploadAll')}}</a> -->
      </v-layout>
      <v-flex xs12 sm12 md12 xl12 v-if="files.length > 0 " style="overflow-x: scroll;overflow-y: hidden;height: 29vh !important; max-width: 70vw !important; display: -webkit-inline-box; background: rgb(234, 234, 234); padding-top: 5vh;" class="containers">
        <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
          <a class="close-classic" @click="removeFile( key )"></a>
          <!-- <v-icon v-if="file.status == 'fail'" style="color: red;">fas fa-exclamation-triangle</v-icon>
          <v-icon v-else-if="file.status == 'success'" style="color: green;">fas fa-check</v-icon> -->
          <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center; margin-top: 2vh;">
            <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 10vh !important; width:20vh !important;display: flex;justify-content: center; object-fit: cover;" />
            <b class="text2">{{ file.file.name }}</b>
            <a v-if="file.status !== 'success' && file.status !== 'process'" style="text-align: center;" @click="submitFiles( key )">
              <p v-if="file.status == 'fail'">{{$t('AnswerQuestion.newuUpload')}} <v-icon small style="color: red;">fas fa-exclamation-triangle</v-icon></p>
              <p v-else-if="file.status == 'success'"><v-icon small style="color: green;">fas fa-check</v-icon></p>
              <p v-else>{{$t('AnswerQuestion.upload')}}</p>

              <!-- <v-icon small v-if="file.status == 'fail'" style="color: red;">fas fa-exclamation-triangle</v-icon>
              <v-icon small v-if="file.status == 'success'" style="color: green;">fas fa-check</v-icon> -->
            </a>
            <v-progress-circular indeterminate color="primary" v-if="file.status == 'process'"></v-progress-circular>
          </div>
          <div v-else style="text-align: center; display: grid; justify-content: center; margin-top: 2vh;" >
            <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
            <b class="text2">{{ file.file.name }}
              <!-- <v-icon v-if="file.status == 'fail'" style="color: red;">fas fa-exclamation-triangle</v-icon>
              <v-icon v-else-if="file.status == 'success'" style="color: green;">fas fa-check</v-icon> -->
            </b>
            <a v-if="file.status !== 'success' && file.status !== 'process'" style="text-align: center;" @click="submitFiles( key )">  
              <p v-if="file.status == 'fail'">{{$t('AnswerQuestion.newuUpload')}} <v-icon small style="color: red;">fas fa-exclamation-triangle</v-icon></p>
              <p v-else-if="file.status == 'success'"><v-icon small style="color: green;">fas fa-check</v-icon></p>
              <p v-else>{{$t('AnswerQuestion.upload')}}</p>
            </a>
             <v-progress-circular indeterminate color="primary" v-if="file.status == 'process'"></v-progress-circular>
          </div>
        </div>
      </v-flex>
    </v-layout>
	</v-app>
</template>
<script>
  import { Decode } from '@/services'
  export default {
    data () {
      return {
        dragAndDropCapable: false,
        files: [],
        token: ''
      }
    },
    mounted () {
      this.dragAndDropCapable = this.determineDragAndDropCapable()
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
          this.$refs.fileform.addEventListener(evt, function (e) {
            e.preventDefault()
            e.stopPropagation()
          })
        }.bind(this))
        this.$refs.fileform.addEventListener('drop', function (e) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push({file: e.dataTransfer.files[i], status: 'waiting'})
            this.getImagePreviews()
          }
        }.bind(this))
      }
    },
    methods: {
      openFileimage () {
        this.$refs.files.click()
      },
      upfile () {
        $('#uploadfile').click()
      },
      determineDragAndDropCapable () {
        var div = document.createElement('div')
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
      },
      getImagePreviews (key) {
        for (let i = 0; i < this.files.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
            let reader = new FileReader()
            reader.addEventListener('load', function () {
              this.$refs['preview' + parseInt(i)][0].src = reader.result
            }.bind(this), false)
            reader.readAsDataURL(this.files[i].file)
            // this.extension(this.files[i].name)
            // console.log(this.extension())
          } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
        }
      },
      handleFilesUpload (key) {
        let uploadedFiles = this.$refs.files.files
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push({file: uploadedFiles[i], status: 'waiting'})
        }
        this.getImagePreviews(key)
        document.querySelector('#files').value = ''
      },
      submitFiles (key) {
        let formData = new FormData()
        // for (var i = 0; i < this.files.length; i++) {
        let file = this.files[key].file
        formData.append('files[' + key + ']', file)
        formData.append('file', file, file.name)
        formData.append('tokenuser', this.token)
        formData.append('appkey', 'QWErty1234')
        this.axios.post(process.env.APIpub + '/save_onebox', formData).then((response) => {
          console.log(response.data)
          if (response.data.status === 'success') {
            // console.log(response)
            this.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์สำเร็จ', 'success')
            // this.files.splice(key, 1)
            this.removeFile(key)
          // this.files.splice( key )
          } else {
            this.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error')
            this.files[key]['status'] = 'fail'
          }
        }, response => {
          console.log('error')
          this.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error')
          this.files[key]['status'] = 'fail'
        }).catch((error) => {
          console.log(error)
          this.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error')
          this.files[key]['status'] = 'fail'
        })
      },
      removeFile (key) {
        this.files.splice(key, 1)
        // this.getImagePreviews(key)
      },
      submitallFiles () {
        var lengthfile = this.files.length
        for (var i = 0; i < lengthfile; i++) {
          this.senbox(i)
        }
      },
      senbox (i) {
        let formData = new FormData()
        var file = this.files[i].file
        // formData.append('files[0]', file)
        formData.append('file', file, file.name)
        formData.append('tokenuser', this.token)
        this.files[i]['status'] = 'process'
        this.axios.post(process.env.APIpub + '/save_onebox', formData).then((response) => {
          if (response.data.status === 'success') {
            console.log('success')
            this.files[i]['status'] = 'success'
            // this.removeFile(i)
            // console.log(this.files.length)
            // return 'true'
            // console.log(this.files.length)
          } else {
            this.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error')
            this.files[i]['status'] = 'fail'
            // return 'false'
          }
        }).catch((error) => {
          console.log(error)
          this.$swal('ส่งไฟล์ไป One box', 'ส่งไฟล์ไม่สำเร็จ', 'error')
          this.files[i]['status'] = 'fail'
        })
      },
      extension (files) {
        var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
        var pdf = ['pdf']
        var file = ['ai', 'ps', 'psd']
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
        var presentation = ['ppt', 'pps', 'pot', 'pptx']
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
        var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
        if (pdf.includes(extension)) {
          return 'fas fa-file-pdf'
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive'
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel'
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint'
        } else if (word.includes(extension)) {
          return 'fas fa-file-word'
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code'
        } else if (image.includes(extension)) {
          return 'fas fa-file-image'
        } else if (file.includes(extension)) {
          return 'fas fa-file'
        } else {
          return 'fas fa-file-alt'
        }
      // return extension[extension.length-1]
      }
    },
    created () {
      var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.token = decoded['tokenuser']
    // console.log(this.token)
    }
  }
</script>
<style scoped>
.text2 {
  white-space: nowrap;
  width: 20vh;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
  form{
    display: block;
    height: 40vh;
    width: 40vh;
    background: #2196f336;
    /*background: 'http://www.clker.com/cliparts/r/i/S/H/R/s/open-box-hi.png';*/
    /*margin: auto;*/
    /*margin-top: 40px;*/
    text-align: center;
    line-height: 400px;
    border-radius: 4px;
    /*border-style: dotted;*/
    border-color: #1a222c;
  }

  div.file-listing{
    width: 400px;
    margin: auto;
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }

  div.file-listing img{
    height: 100px;
  }

  div.remove-container{
    text-align: center;
  }

  div.remove-container a{
    color: red;
    cursor: pointer;
  }

  a.submit-button{
    display: block;
    margin: auto;
    text-align: center;
    width: 200px;
    padding: 10px;
    text-transform: uppercase;
    background-color: #CCC;
    color: white;
    font-weight: bold;
    margin-top: 20px;
  }

  progress{
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  input[type="file"]{
    position: absolute;
    top: -500px;
  }
  div.file-listing img{
    max-width: 90%;
  }
  .borderfile {
    border: 1px solid #00000036;
    border-radius: 5px;
    width: 20vw !important;
    height: 20vh !important;
    position: relative;
    background: white;
}
.containers {
  width: 576px; margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

[class*='close-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  position: absolute;
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
</style>




// WEBPACK FOOTER //
// src/components/chat/settings/Dropfile.vue